<template>
  <div class="login">
    <aside class="login__side">
      <div class="login__side-inner">
        <div class="login__brand" @click="$router.push('/')">
          <span class="login__brand-mark">S</span>
          <strong>Sauda</strong>
        </div>

        <div class="login__side-text">
          <h2>Касса и учёт для вашего магазина</h2>
          <p>Продажи, склад, скидки и аналитика — всё в одном месте</p>
        </div>

        <ul class="login__side-list">
          <li><i class="mdi mdi-point-of-sale"></i> Быстрые продажи с любого устройства</li>
          <li><i class="mdi mdi-warehouse"></i> Остатки списываются автоматически</li>
          <li><i class="mdi mdi-account-group-outline"></i> Несколько кассиров с правами</li>
          <li><i class="mdi mdi-chart-line"></i> Выручка и прибыль в реальном времени</li>
        </ul>
      </div>
    </aside>

    <main class="login__main">
      <div class="login__mobile-brand" @click="$router.push('/')">
        <span class="login__brand-mark">S</span>
        <strong>Sauda</strong>
        <small>Касса и учёт для магазина</small>
      </div>

      <form class="login__card" @submit.prevent="loginRequest">
        <div class="login__card-head">
          <h1>Вход в кассу</h1>
          <p>Введите e-mail и пароль вашего аккаунта</p>
        </div>

        <label class="login__field">
          <span>E-mail</span>
          <div class="login__input">
            <i class="mdi mdi-email-outline"></i>
            <input
              v-model.trim="login"
              type="email"
              placeholder="you@example.com"
              autocomplete="username"
              required
            >
          </div>
        </label>

        <label class="login__field">
          <span>Пароль</span>
          <div class="login__input">
            <i class="mdi mdi-lock-outline"></i>
            <input
              v-model="password"
              :type="showPassword ? 'text' : 'password'"
              placeholder="Ваш пароль"
              autocomplete="current-password"
              required
            >
            <button type="button" class="login__eye" @click="showPassword = !showPassword">
              <i :class="['mdi', showPassword ? 'mdi-eye-off-outline' : 'mdi-eye-outline']"></i>
            </button>
          </div>
        </label>

        <button type="submit" class="login__submit" :disabled="loading">
          <i v-if="loading" class="mdi mdi-loading mdi-spin"></i>
          {{ loading ? 'Входим...' : 'Войти' }}
        </button>

        <SocialAuthButtons divider="или войти через" />

        <p class="login__register">
          Нет аккаунта?
          <a @click.prevent="$router.push('/register')">Зарегистрироваться</a>
        </p>

        <button type="button" class="login__back" @click="$router.push('/')">
          <i class="mdi mdi-arrow-left"></i>
          На главную
        </button>
      </form>
    </main>
  </div>
</template>

<script>
import { persistAuthSession } from '@/api/auth'
import SocialAuthButtons from '@/components/SocialAuthButtons'

export default {
  name: 'KassaLogin',
  components: { SocialAuthButtons },
  data() {
    return {
      login: '',
      password: '',
      showPassword: false,
      loading: false,
    }
  },
  methods: {
    loginRequest() {
      if (!this.login || !this.password) return

      this.loading = true
      this.$axios({
        method: 'post',
        url: this.$API_URL + 'login',
        data: {
          email: this.login,
          password: this.password,
        },
      })
        .then((response) => {
          persistAuthSession(response.data)
          localStorage.setItem('is_platform_admin', response.data.is_platform_admin ? '1' : '0')
          this.$router.push(response.data.is_platform_admin ? '/super-admin' : '/cash')
        })
        .catch((error) => {
          const errors = error.response && error.response.data && error.response.data.errors
          if (errors) {
            for (let key in errors) {
              this.$toast.open({
                message: errors[key][0],
                type: 'warning',
                position: 'bottom',
                duration: 4000,
                queue: true,
              })
            }
          } else {
            this.$toast.open({
              message:
                (error.response && error.response.data && error.response.data.error) ||
                'Неверный логин или пароль',
              type: 'error',
              position: 'bottom',
              duration: 4000,
              queue: true,
            })
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
}
</script>

<style scoped lang="scss">
$ink: #152033;
$muted: #6b7a90;
$accent: #0b4f8a;
$line: #d9e2ec;

.login {
  display: flex;
  min-height: 100vh;
  min-height: -webkit-fill-available;
  min-height: 100dvh;
  background: #f6f9fc;
}

/* ---------- Левая панель ---------- */
.login__side {
  width: 44%;
  color: #fff;
  background:
    radial-gradient(circle at 20% 15%, rgba(90, 168, 220, 0.26), transparent 40%),
    linear-gradient(160deg, #143252 0%, #10243a 60%, #0d1c2e 100%);
}

.login__side-inner {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 40px 48px;
}

.login__brand {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  align-self: flex-start;

  strong {
    font-size: 19px;
    font-weight: 800;
  }
}

.login__brand-mark {
  width: 40px;
  height: 40px;
  border-radius: 12px;
  display: grid;
  place-items: center;
  background: linear-gradient(180deg, #fff, #eef5fb);
  color: $accent;
  font-weight: 800;
  font-size: 18px;
}

.login__side-text {
  margin-top: auto;

  h2 {
    margin: 0 0 10px;
    font-size: 30px;
    font-weight: 800;
    line-height: 1.25;
    letter-spacing: -0.02em;
    max-width: 380px;
  }

  p {
    margin: 0 0 28px;
    opacity: 0.8;
    font-size: 15px;
  }
}

.login__side-list {
  list-style: none;
  margin: 0 0 20px;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 14px;

  li {
    display: flex;
    align-items: center;
    gap: 12px;
    font-size: 14.5px;
    opacity: 0.92;
  }

  .mdi {
    width: 36px;
    height: 36px;
    flex-shrink: 0;
    display: grid;
    place-items: center;
    border-radius: 10px;
    background: rgba(255, 255, 255, 0.1);
    font-size: 18px;
  }
}

/* ---------- Форма ---------- */
.login__main {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 32px 20px;
}

/* Брендинг над формой — только на мобильных */
.login__mobile-brand {
  display: none;
}

.login__card {
  width: 100%;
  max-width: 420px;
  padding: 36px 34px 28px;
  background: #fff;
  border: 1px solid #e3ebf3;
  border-radius: 22px;
  box-shadow: 0 20px 60px rgba(18, 32, 51, 0.08);
}

.login__card-head {
  margin-bottom: 26px;

  h1 {
    margin: 0 0 6px;
    font-size: 26px;
    font-weight: 800;
    letter-spacing: -0.02em;
    color: $ink;
  }

  p {
    margin: 0;
    color: $muted;
    font-size: 14px;
  }
}

.login__field {
  display: block;
  margin-bottom: 16px;

  > span {
    display: block;
    margin-bottom: 7px;
    font-size: 13px;
    font-weight: 700;
    color: $ink;
  }
}

.login__input {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 0 14px;
  border: 1.5px solid $line;
  border-radius: 13px;
  background: #fbfdff;
  transition: border-color 0.18s ease, box-shadow 0.18s ease;

  &:focus-within {
    border-color: $accent;
    box-shadow: 0 0 0 4px rgba(11, 79, 138, 0.1);
  }

  > .mdi {
    color: $muted;
    font-size: 19px;
  }

  input {
    flex: 1;
    min-width: 0;
    padding: 14px 0;
    border: 0;
    background: transparent;
    font-size: 15px;
    color: $ink;

    &::placeholder {
      color: #9fb0c2;
    }
  }
}

.login__eye {
  border: 0;
  background: transparent;
  padding: 4px;
  cursor: pointer;
  color: $muted;

  .mdi {
    font-size: 19px;
  }

  &:hover {
    color: $accent;
  }
}

.login__submit {
  width: 100%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 6px;
  padding: 15px;
  border: 0;
  border-radius: 14px;
  background: linear-gradient(135deg, #12324f, $accent);
  color: #fff;
  font-size: 16px;
  font-weight: 780;
  cursor: pointer;
  transition: opacity 0.18s ease, transform 0.15s ease;

  &:hover:not(:disabled) {
    transform: translateY(-1px);
  }

  &:disabled {
    opacity: 0.7;
    cursor: wait;
  }

  .mdi {
    font-size: 18px;
  }
}

.login__register {
  margin: 18px 0 0;
  text-align: center;
  font-size: 14px;
  color: $muted;

  a {
    color: $accent;
    font-weight: 700;
    cursor: pointer;

    &:hover {
      text-decoration: underline;
    }
  }
}

.login__back {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin: 18px auto 0;
  padding: 8px 12px;
  border: 0;
  border-radius: 10px;
  background: transparent;
  color: $muted;
  font-size: 13px;
  font-weight: 650;
  cursor: pointer;

  .mdi {
    font-size: 16px;
  }

  &:hover {
    color: $accent;
    background: #eef4fa;
  }
}

.login__card .login__back {
  display: flex;
  width: fit-content;
}

/* ---------- Адаптив ---------- */
@media (max-width: 900px) {
  .login__side {
    display: none;
  }

  /* Тёмный фирменный фон на весь экран, карточка «плавает» на нём */
  .login {
    background:
      radial-gradient(circle at 80% -10%, rgba(90, 168, 220, 0.28), transparent 45%),
      radial-gradient(circle at 10% 100%, rgba(245, 158, 11, 0.1), transparent 40%),
      linear-gradient(165deg, #143252 0%, #10243a 55%, #0d1c2e 100%);
  }

  .login__main {
    justify-content: flex-start;
    padding: 40px 18px 28px;
    padding-top: calc(40px + env(safe-area-inset-top, 0px));
    padding-bottom: calc(28px + env(safe-area-inset-bottom, 0px));
  }

  .login__mobile-brand {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
    margin-bottom: 26px;
    color: #fff;
    cursor: pointer;
    text-align: center;

    .login__brand-mark {
      width: 52px;
      height: 52px;
      border-radius: 16px;
      font-size: 24px;
      margin-bottom: 8px;
      box-shadow: 0 10px 26px rgba(0, 0, 0, 0.3);
    }

    strong {
      font-size: 22px;
      font-weight: 800;
      letter-spacing: -0.01em;
    }

    small {
      font-size: 13.5px;
      opacity: 0.75;
    }
  }

  .login__card {
    border: 0;
    border-radius: 24px;
    box-shadow: 0 24px 60px rgba(0, 0, 0, 0.35);
  }
}

@media (max-width: 480px) {
  .login__main {
    padding: 32px 14px 24px;
    padding-top: calc(32px + env(safe-area-inset-top, 0px));
    padding-bottom: calc(24px + env(safe-area-inset-bottom, 0px));
    padding-left: calc(14px + env(safe-area-inset-left, 0px));
    padding-right: calc(14px + env(safe-area-inset-right, 0px));
  }

  .login__card {
    padding: 26px 20px 20px;
  }

  .login__card-head h1 {
    font-size: 23px;
  }

  /* 16px — чтобы iOS не зумил поле при фокусе */
  .login__input input {
    font-size: 16px;
    padding: 15px 0;
  }

  .login__submit {
    padding: 16px;
  }
}
</style>
